import React from "react";
import className from "classnames";
import ClockIcon from "react-icons/lib/io/android-time";
import useCountDownTime from "@unibuddy/machop/LiveEvents/components/CountDown/useCountDownTime";
import {Icon} from "./LiveEventRealTimeStats";
import s from "./LiveEventRealTimeStats.pcss";

export const Number = ({children, color}) => (
    <span
        className={className(s.number, {
            [s[color]]: !!color,
        })}
    >
        {children}
    </span>
);

const CountDown = ({end}) => {
    const {minutes, hours, duration} = useCountDownTime(end);
    const isCloseToEnd = hours === 0 && minutes < 5;
    const color = isCloseToEnd && "danger";

    return (
        duration.asHours() < 12 && (
            <div data-test-id="time-remaining" className={s.container}>
                <Icon>
                    <ClockIcon />
                </Icon>
                <Number color={color}>{hours}</Number> hrs <Number color={color}>{minutes}</Number>{" "}
                mins remaining
            </div>
        )
    );
};

export default CountDown;
